export default {
  title: 'Mese',
  count_one: '{{count}} masă',
  count_few: '{{count}} mese',
  count_other: '{{count}} de mese',
  filtered_count: '{{shown}} din {{count}} mese',
  intro:
    'Fiecare masă are propriul link și cod QR. Oaspeții care îl scanează comandă la acea masă, iar masa apare la fiecare comandă.',
  migrated: {
    title: 'Serviciul în cameră/la masă este acum Comenzi la masă',
    description:
      'Am adăugat câte o masă pentru fiecare locație, cu numele acesteia, ca oaspeții să poată continua să comande. Redenumiți-le conform meselor dvs. sau adăugați altele.',
  },
  add: {
    label: 'Adaugă o masă',
    placeholder: 'ex. 7, 1A sau Terasă 2',
    button: 'Adaugă masa',
  },
  errors: {
    empty: 'Introduceți numele mesei.',
    duplicate: 'Există deja o masă numită „{{name}}”.',
    too_long: 'Numele unei mese poate avea cel mult {{max}} de caractere.',
  },
  columns: {
    order: 'Ordine',
    table: 'Masă și link',
    on: 'Activ',
    copy: 'Copiază linkul',
    qr: 'Cod QR',
    actions: 'Acțiuni',
  },
  switch: {
    on: 'Activ',
    off: 'Inactiv',
  },
  buttons: {
    copy: 'Copiază linkul',
    copied: 'Copiat',
    download_qr: 'Descarcă codul QR',
    qr_short: 'Cod QR',
    rename: 'Redenumește',
    delete: 'Șterge',
    save: 'Salvează',
    cancel: 'Anulează',
  },
  aria: {
    move: 'Mută {{name}} (tastele săgeată)',
    switch: '{{name}} activ',
    copy: 'Copiază linkul pentru {{name}}',
    copied: 'Link copiat',
    download_qr: 'Descarcă codul QR pentru {{name}}',
    rename: 'Redenumește {{name}}',
    delete: 'Șterge {{name}}',
    more: 'Mai multe pentru {{name}}',
    new_name: 'Nume nou pentru {{name}}',
  },
  tooltips: {
    move: 'Trageți pentru a reordona',
    move_disabled: 'Ștergeți căutarea pentru a reordona',
  },
  rename_hint: 'Linkul și codul QR rămân aceleași.',
  no_link: 'Încă nu există adresă de magazin',
  search: {
    placeholder: 'Caută mese',
    no_results: 'Nicio masă numită „{{text}}”.',
  },
  load_failed: {
    title: 'Mesele nu au putut fi încărcate.',
    retry: 'Încearcă din nou',
  },
  empty: {
    title: 'Nicio masă încă',
    text: 'Adăugați mesele mai sus pentru a primi un link și un cod QR pentru fiecare. Oaspeții nu pot comanda la masă până nu adăugați una.',
  },
  delete: {
    title: 'Ștergeți masa „{{name}}”?',
    warning:
      'Codurile QR tipărite pentru această masă nu vor mai funcționa. Oaspeții care scanează unul sunt rugați să se adreseze personalului.',
    softer: 'Pentru a opri comenzile la această masă pentru o perioadă, dezactivați-o.',
    confirm: 'Șterge masa',
    cancel: 'Anulează',
  },
  announcements: {
    moved: '„{{name}}” a fost mutată pe poziția {{position}} din {{count}}.',
    instructions: 'Pentru a muta o masă, selectați mânerul ei și apăsați săgeata sus sau jos.',
  },
  qr_image: {
    table: 'Masă',
  },
  toasts: {
    added: 'Masa „{{name}}” a fost adăugată',
    renamed: '„{{old}}” redenumită în „{{name}}”',
    deleted: 'Masa „{{name}}” a fost ștearsă',
    switched_on: '„{{name}}” activată',
    switched_off: '„{{name}}” dezactivată',
    failed_to_save: 'Nu s-a salvat. Încercați din nou.',
    failed_to_reorder: 'Noua ordine nu s-a salvat. Încercați din nou.',
    failed_to_download_qr: 'Codul QR nu a putut fi salvat. Încercați din nou.',
    copy_failed: 'Linkul nu a putut fi copiat. Încercați din nou.',
  },
};
